// Compact ± stepper for the audio/visual sync calibration.
// Click the centre value to reset to 0.

type Props = {
  value: number;
  onChange: (next: number) => void;
};

const STEP_MS = 5;
const MIN_MS = -500;
const MAX_MS = 500;

export function SyncOffset({ value, onChange }: Props) {
  const display = `${value > 0 ? '+' : ''}${value}ms`;
  const commit = (next: number) => {
    onChange(Math.max(MIN_MS, Math.min(MAX_MS, next)));
  };
  const decDisabled = value <= MIN_MS;
  const incDisabled = value >= MAX_MS;
  return (
    <div className="flex flex-col items-end">
      <span className="text-[9px] tracking-[0.3em] uppercase text-zinc-500 mb-0.5">
        sync
      </span>
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => commit(value - STEP_MS)}
          disabled={decDisabled}
          aria-label={`Shift visual −${STEP_MS}ms`}
          className="text-zinc-500 hover:text-zinc-200 disabled:opacity-30 disabled:hover:text-zinc-500 text-sm w-4 leading-none"
        >
          −
        </button>
        <button
          type="button"
          onClick={() => commit(0)}
          title="Reset to 0"
          className={
            'font-display text-lg leading-none tabular-nums min-w-[5ch] text-center ' +
            (value === 0 ? 'text-zinc-500' : 'text-yellow-300')
          }
        >
          {display}
        </button>
        <button
          type="button"
          onClick={() => commit(value + STEP_MS)}
          disabled={incDisabled}
          aria-label={`Shift visual +${STEP_MS}ms`}
          className="text-zinc-500 hover:text-zinc-200 disabled:opacity-30 disabled:hover:text-zinc-500 text-sm w-4 leading-none"
        >
          +
        </button>
      </div>
    </div>
  );
}
